module.exports = __webpack_public_path__ + "img/ct-icon-telephone.53374bf8.svg";